import React, { useCallback, useEffect, useState } from 'react'
import Footer from '@app/components/Footer/Footer'
import Navbar from '@app/components/Navbar/Navbar'
import { useNavigate, useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Label from '@app/components/Label'
import { QuizStep, updateQuiz } from '@app/store/slices/quiz'
import { useAppDispatch, useAppSelector } from '@app/store/hooks'
import programs from '@app/programs'
import useCampaignHref from '@app/hooks/useCampaignHref'
import S from './styles'
import ModelButton from './components/ModelButton'
import QuizHeader from './components/QuizHeader/QuizHeader'
import useQuizRedirect from './useQuizRedirect'
import RedirectPartialView from './RedirectPartialView'

const ModelCheck = () => {
  const quiz = useAppSelector(state => state.quiz)
  const [showWarning, setShowWarning] = useState(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { program } = useParams<{ program: string }>()

  const { href: quizPurchaseHref } = useCampaignHref({ requestPath: 'quiz/purchase' })
  const { isRedirecting } = useQuizRedirect({ requestedStep: QuizStep.MODEL })

  /**
   * Update the store with the user's model choice
   */
  const progress = useCallback(
    (model: string) => {
      dispatch(updateQuiz({ purchaseModel: model, step: QuizStep.PURCHASE, prevStep: QuizStep.MODEL }))
    },
    [dispatch]
  )

  /**
   * Redirect to the next step if the step has changed in the store
   */
  useEffect(() => {
    if (quiz.step === QuizStep.PURCHASE) {
      navigate(quizPurchaseHref)
    }
  }, [navigate, quiz.step, quizPurchaseHref])

  if (isRedirecting) {
    return <RedirectPartialView />
  }

  return (
    <>
      <Navbar />
      <S.QuizMain>
        <QuizHeader
          title={<FormattedMessage id="quiz_purchased_product_page.content.base.title" />}
          intro={<FormattedMessage id="quiz_purchased_product_page.content.base.intro" />}
          nextStep={<FormattedMessage id="quiz_purchased_product_page.content.base.button_text" />}
          progress={3}
          step={1}
        />
        <S.Form className="biggest">
          <S.Field>
            <Label>
              <FormattedMessage id="quiz_purchased_product_page.content.questions.purchased_model.label" />
            </Label>
            <S.FormGroup>
              {program &&
                program in programs &&
                programs[program].products.map(p => (
                  <ModelButton key={p.name} text={p.name} img={p.img} onClick={() => progress(p.name)} />
                ))}
            </S.FormGroup>
          </S.Field>
        </S.Form>
      </S.QuizMain>
      {showWarning && (
        <S.Dialog>
          <h2>Warning</h2>
          <button type="button" onClick={() => setShowWarning(false)}>
            Close
          </button>
        </S.Dialog>
      )}
      <Footer />
    </>
  )
}

export default ModelCheck
